import Moment from "react-moment";

interface IDocumentRefProps {
  title: String;
  date: Date;
  selected: any;
}
export default function DocumentRef({
  selected,
  title,
  date,
}: IDocumentRefProps) {
  return (
    <>
      <div className="bg-gray-200 border-b border-t border-r border-l border-black mb-2 flex flex-row justify-between items-center text-xs">
        <div className=" border-black w-full sm:w-4/12">
          <span className="text-2xl ml-4 font-bold">{title}</span>
        </div>
        <div className=" flex flex-col w-full sm:w-3/12 text-xs">
          <div className="border-black ">
            <span className="px-2 inline-block align-middle">
              TIN : {selected?.tin ? selected?.tin : "-"}
            </span>
          </div>
          <div className="">
            <span className="px-2">
              VRN: {selected?.vrn ? selected?.vrn : "-"}
            </span>
          </div>
        </div>

        <div className={`border-l border-black  w-56`}>
          <div className="flex  items-center px-2 border-b border-black ">
            <div className="border-r border-black w-24">ACC NO :</div>
            <div className="w-full text-left px-2">
              {selected?.account ? selected?.account : "-"}
            </div>
          </div>
          <div className="flex  items-center px-2 w-56">
            <div className="border-r border-black w-24">DATE :</div>
            <div className="w-full text-left px-2">
              <Moment format="Do MMM, YYYY">{date}</Moment>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
